import { useState } from 'react';
import './Login.css';
import PasswordInput from './PasswordInput';
import Icon from './Icon';

function ForcePasswordChange({ username, onSet, onLogout }) {
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    if (!pw) { setError('Password is required.'); return; }
    if (pw !== confirm) { setError('Passwords do not match.'); return; }
    const err = await onSet(pw);
    if (err) setError(err);
  }

  return (
    <div className="login-screen">
      <form className="login-card login-form" onSubmit={submit} noValidate>
        <div className="login-brand"><span className="login-logo"><Icon name="brand" size={22} /></span> iBetterAgent</div>
        <h2 className="login-title">Set a new password</h2>
        <div className="login-reset-for">
          Welcome, <strong>{username}</strong>. For security, please choose your own password before continuing.
        </div>
        {error && <div className="login-error">⚠ {error}</div>}

        <label className="login-label">New Password</label>
        <PasswordInput className="login-input" autoFocus value={pw}
          onChange={e => { setPw(e.target.value); setError(''); }} />
        <p className="login-pw-hint">At least 8 characters, including an uppercase letter, a lowercase letter, and a number.</p>

        <label className="login-label">Confirm Password</label>
        <PasswordInput className="login-input" value={confirm}
          onChange={e => { setConfirm(e.target.value); setError(''); }} />

        <button type="submit" className="login-btn">Set Password &amp; Continue</button>
        <p className="login-switch">
          <button type="button" className="login-link" onClick={onLogout}>Cancel and log out</button>
        </p>
      </form>
    </div>
  );
}

export default ForcePasswordChange;
